import api from '../api';
const routes = require('routes.js.erb');

const getUser = function ({ commit }, params = {}) {
  return api.get(routes.api_v5_users_path(params)).then(result => commit("setUser", result["data"]["data"]["user"]));
}

const updateUser = function ({ commit }, body) {
  return api.put(routes.api_v5_user_path(body.userId), body.params).then(result => commit("setUser", result["data"]["data"]["user"]))
}

const searchUsers = function ({ }, params = {}) {
  return api.get(routes.search_api_v5_organization_users_path(), params);
}

const autoJoin = function ({ }, params = {}) {
  return api.put(routes.autojoin_api_v5_users_path(), params);
}

const enableBeta = function ({ }) {
  return api.put(routes.api_v5_beta_signup_path()).then(() => {
    window.location.reload();
  });
}

export { getUser, updateUser, searchUsers, autoJoin, enableBeta };
